// ref: https://en.wikipedia.org/wiki/JSFuck

const esotericSubsetsList = [
  // +
  '(+(+!+[]+(!+[]+[])[!+[]+!+[]+!+[]]+[+!+[]]+[+[]]+[+[]])+[])[!+[]+!+[]]',
  // .
  '(+(+!+[]+[+!+[]]+(!![]+[])[!+[]+!+[]+!+[]]+[!+[]+!+[]]+[+[]])+[])[+!+[]]',
  // '0'
  '+[]',
  // 1
  '+!![]',
  '+!+[]',
  // 2
  '!![]+!![]',
  '!+[]+!+[]',
  // 3
  '!![]+!![]+!![]',
  '!+[]+!+[]+!+[]',
  // 4
  '!![]+!![]+!![]+!![]',
  '!+[]+!+[]+!+[]+!+[]',
  // 5
  '!![]+!![]+!![]+!![]+!![]',
  '!+[]+!+[]+!+[]+!+[]+!+[]',
  // 6
  '!![]+!![]+!![]+!![]+!![]+!![]',
  '!+[]+!+[]+!+[]+!+[]+!+[]+!+[]',
  // 7
  '!![]+!![]+!![]+!![]+!![]+!![]+!![]',
  '!+[]+!+[]+!+[]+!+[]+!+[]+!+[]+!+[]',
  // 8
  '!![]+!![]+!![]+!![]+!![]+!![]+!![]+!![]',
  '!+[]+!+[]+!+[]+!+[]+!+[]+!+[]+!+[]+!+[]',
  // 9
  '!![]+!![]+!![]+!![]+!![]+!![]+!![]+!![]+!![]',
  '!+[]+!+[]+!+[]+!+[]+!+[]+!+[]+!+[]+!+[]+!+[]',
  // a
  '(![]+[])[+!+[]]',
  // b
  '([]+{})[!![]+!![]]',
  // c
  '([]+[][(![]+[])[+!![]]+(!![]+[])[+[]]])[!![]+!![]+!![]]',
  // d
  '([][[]]+[])[!+[]+!+[]]',
  // e
  '(!![]+[])[!+[]+!+[]+!+[]]',
  // f
  '(![]+[])[+[]]',
  // i
  '([![]]+[][[]])[+!+[]+[+[]]]',
  // I
  '(+(+!+[]+(!+[]+[])[!+[]+!+[]+!+[]]+(+!+[])+(+[])+(+[])+(+[]))+[])[+[]]',
  // j
  '([]+{})[!![]+!![]+!![]]',
  // l
  '(![]+[])[!+[]+!+[]]',
  // N
  '(+[![]]+[])[+[]]',
  // n
  '([][[]]+[])[+!+[]]',
  // o
  '(!![]+[][(![]+[])[+!![]]+(!![]+[])[+[]]])[+!![]+[+[]]]', //
  // r
  '(!+[]+[])[+!+[]]',
  // s
  '(![]+[])[!+[]+!+[]+!+[]]',
  // t
  '(!+[]+[])[+[]]',
  // u
  '([][[]]+[])[+[]]',
  // y
  '(+[![]]+[+(+!+[]+(!+[]+[])[!+[]+!+[]+!+[]]+(+!+[])+(+[])+(+[])+(+[]))])[+!+[]+[+[]]]'
];

export default function isCodeObfuscatedByEsotericSubset(code) {
  if (code == null) return false;

  return esotericSubsetsList.some(value => code.includes(value));
}
